import { PRODUCTS_ACCESS } from "@/helpers/permissionsConstant";

export default [
  {
    title: 'Business Settings',
    icon: 'SettingsIcon',
    gate: PRODUCTS_ACCESS,
    children: [
      {
        title: 'General Info',
        route: 'settings-general',
        gate: PRODUCTS_ACCESS,
      },
      {
  	title: 'Theme Settings',
  	route: 'settings-theme',
  	gate: PRODUCTS_ACCESS,
	},
      {
        title: 'Social Links',
        route: 'settings-social',
        gate: PRODUCTS_ACCESS,
      },
    ],
  },
]
